<template>
  <v-col id="menu-faq" class="pa-0">
    <v-expansion-panels variant="accordion">
      <v-expansion-panel title="Wie beauftrage ich ein Unternehmen?">
        <v-expansion-panel-text>
          Geben Sie Ihre vollständige Adresse ein, wählen Sie die passende Branche, die gewünschte Kategorie, Ihre Leistungen, die Art des Auftrags, ein Unternehmen und einen Wunschtermin aus. Danach melden Sie sich an oder registrieren sich und senden Ihre Anfrage ab.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel title="Was passiert nach dem Senden?">
        <v-expansion-panel-text>
          Das ausgewählte Unternehmen erhält Ihre Anfrage und meldet sich wegen des Wunschtermins, der Echtheitsprüfung und der Terminbestätigung bei Ihnen.
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel title="Wie wird der Preis berechnet?">
        <v-expansion-panel-text>
          Der Preisrechner kalkuliert anhand Ihrer Angaben, der ausgewählten Leistungen, der Stundenpreise des Unternehmens sowie möglicher Fahrtkosten und Umsatzsteuer. Der endgültige Preis kann vor Beginn der Ausführung mit dem Unternehmen abgestimmt werden.
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
export default {
  name: "FAQ"
}
</script>
